import { PublicClientApplication } from "@azure/msal-browser";

import { loadConfig } from "../config";

let authorizationProvider;

const getAuthenticationConfig = async () => {
  const config = await loadConfig();
  return {
    auth: {
      authority: "https://login.microsoftonline.com/" + config.tenantId,
      clientId: config.clientId,
      redirectUri: config.apiUrl,
      scopes: [config.scope]
    },
    cache: {
      cacheLocation: "localStorage"
    }
  };
};

export const getAuthorizationProvider = async () => {
  if (authorizationProvider) {
    return authorizationProvider;
  }

  const msalConfig = await getAuthenticationConfig();
  authorizationProvider = new PublicClientApplication(msalConfig);
  await authorizationProvider.initialize();

  return authorizationProvider;
};